<script setup>
import StatusBadge from '@/components/shared/core/StatusBadge.vue'
import LabelValue from '@/components/shared/transform/LabelValue.vue'
import {Enrollment} from '@/models/enrollment.model.js'
import {enrollmentStatuses, enrollmentStatusOptions} from '@/constants/enrollments.js'
import {contentTypes} from '@/constants/content.js'
import {componentColors} from '@/constants/components.js'
import {toRefs, computed} from 'vue'

//Props
const props = defineProps({
  enrollment: {
    type: Enrollment,
    required: true,
  },
})

//Get refs
const {enrollment} = toRefs(props)

//Badge text
const text = computed(() => {

  //Get enrollment data
  const {
    contentType,
    isPaused,
    shouldShowProgress,
    numSteps,
    numCompleted,
  } = enrollment.value

  //Nudge, always just show "Nudge"
  if (contentType === contentTypes.NUDGE) {
    return 'Nudge'
  }

  //Show progress
  if (shouldShowProgress) {
    if (isPaused) {
      return `Paused ${numCompleted || 0}/${numSteps}`
    }
    if (contentType === contentTypes.SURVEY) {
      return `Survey ${numCompleted || 0}/${numSteps}`
    }
    return `Lesson ${numCompleted || 0}/${numSteps}`
  }

  //Will fall back to just status
  return null
})

//Badge color for different enrollment statuses
const color = computed(() => {
  switch (enrollment.value.status) {
    case enrollmentStatuses.COMPLETED:
      return componentColors.SUCCESS
    case enrollmentStatuses.PAUSED:
      return componentColors.WARNING
    case enrollmentStatuses.ERROR:
    case enrollmentStatuses.WHATSAPP_WINDOW_VIOLATED:
      return componentColors.DANGER
    case enrollmentStatuses.DISABLED:
    case enrollmentStatuses.OPTED_OUT:
    case enrollmentStatuses.CANCELED:
      return componentColors.MUTED
    default:
      return ''
  }
})
</script>

<template>
  <StatusBadge
    :color="color"
    v-bind="$attrs"
  >
    <template v-if="text">
      {{ text }}
    </template>
    <LabelValue
      v-else
      :options="enrollmentStatusOptions"
      :value="enrollment.status"
      show-unknown
    />
  </StatusBadge>
</template>
